<!-- #737: Drei Textzeilen. Utility-Klassen direkt im Template — src/tailwind.css gibt es auf 4.0.x
     nicht. Der Rahmen gehoert der host-Klasse, hier also kein border-b. -->
<div
  class="flex flex-col px-5 py-2 text-[14px] leading-[1.325rem]"
  [class.cursor-pointer]="linkToDetail()"
  [class.hover:bg-gray-50]="linkToDetail()"
  (click)="onRowClick($event)">

  <!-- Zeile 1: Status, Kanal, und — nur in der flachen Liste — Typ und Empfaenger -->
  <div class="flex flex-row items-center flex-wrap gap-x-2">
    <p-tag
      [value]="statusLabelKey() | translate"
      [severity]="statusSeverity()">
    </p-tag>
    <span>{{ channelLabelKey() | translate }}</span>
    @if (showParentFields()) {
      <span class="text-[#848488]">·</span>
      <!-- typeKey bleibt bewusst technisch: das Audit-DTO liefert kein Label, und fuer Support ist
           der Schluessel die brauchbarere Information. -->
      <span class="font-medium break-all">{{ entry().typeKey }}</span>
      <span class="text-[#848488]">·</span>
      <span class="text-[#848488] break-all">{{ recipientDisplay() }}</span>
    }
  </div>

  <!-- Zeile 2: Grund, Versuche, Zeiten -->
  <div class="flex flex-row flex-wrap gap-x-2 text-[#848488]">
    <span>{{ reasonLabelKey() | translate }}</span>
    <span>·</span>
    <span>{{ 'core.notificationDiagnostics.row.attempts' | translate }}: {{ entry().attempts }}</span>
    <span>·</span>
    <span>{{ 'core.notificationDiagnostics.row.createdAt' | translate }}: {{ entry().createdAt | date:'dd.MM.yyyy HH:mm' }}</span>
    @if (entry().sentAt) {
      <span>·</span>
      <span>{{ 'core.notificationDiagnostics.row.sentAt' | translate }}: {{ entry().sentAt | date:'dd.MM.yyyy HH:mm' }}</span>
    }
    <!-- openedAt nur wenn vorhanden: "zugestellt, aber nie geoeffnet" ist ein eigener Befund und
         zeigt sich als fehlende Angabe. -->
    @if (entry().openedAt) {
      <span>·</span>
      <span>{{ 'core.notificationDiagnostics.row.openedAt' | translate }}: {{ entry().openedAt | date:'dd.MM.yyyy HH:mm' }}</span>
    }
    <!-- notBefore nur solange nichts gesendet wurde: PENDING mit notBefore in der Zukunft wartet auf
         den naechsten Versuch oder auf das Aggregationsfenster. -->
    @if (showNotBefore()) {
      <span>·</span>
      <span>{{ 'core.notificationDiagnostics.row.notBefore' | translate }}: {{ entry().notBefore | date:'dd.MM.yyyy HH:mm' }}</span>
    }
  </div>

  <!-- Zeile 3: roher Fehlertext, nur wenn vorhanden. Bei FAILED mit erschoepfter Retry-Kette steht
       hier die eigentliche Antwort auf den Support-Fall. -->
  @if (entry().lastError) {
    <div class="text-[#c0123c] break-all">{{ entry().lastError }}</div>
  }
</div>
